import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import { colors } from '@/constants';
import { TFunction } from 'i18next';
import {
    SylndrCertifiedShield,
    SylndrLiteStars,
    SylndrD2CIcon,
    SylndrDealerIconOutlined,
} from 'public/Images';

export const CATEGORY_BADGE_CONFIG = {
    [CarTypesEnum.CERTIFIED]: {
        bgColor: colors['primary-50'],
        textColor: colors['primary-700'],
        icon: SylndrCertifiedShield.src,
        filterIcon: SylndrCertifiedShield,
        title: 'Certified Cars',
        label: 'Certified',
        desc: 'CertifiedDesc',
        isNew: false,
    },
    [CarTypesEnum.LITE]: {
        bgColor: colors['lite-badge'],
        textColor: colors['blue-600'],
        icon: SylndrLiteStars.src,
        filterIcon: SylndrLiteStars,
        title: 'Lite Cars',
        isNew: true,
        label: 'Lite',
        desc: 'LiteDesc',
    },
    [CarTypesEnum.Dealer]: {
        bgColor: colors['orange-100'],
        textColor: colors['orange-700'],
        icon: SylndrD2CIcon.src,
        filterIcon: SylndrDealerIconOutlined,
        title: 'Dealer Cars',
        isNew: true,
        label: 'certifiedDealer',
        desc: 'DealerDesc',
    },
};

export const getCategoryBadgeConfig = (carType: CarTypesEnum, t: TFunction) => {
    const baseConfig =
        CATEGORY_BADGE_CONFIG[carType] ||
        CATEGORY_BADGE_CONFIG[CarTypesEnum.LITE];

    return {
        ...baseConfig,
        title: t(baseConfig.title),
        label: t(baseConfig.label),
        desc: t(baseConfig.desc),
    };
};
